module.exports = __webpack_public_path__ + "static/media/drupal.7a1ae10f.svg";